import { Injectable } from '@angular/core';
import { Http, Response, Headers, URLSearchParams, RequestOptionsArgs, RequestOptions, RequestMethod } from '@angular/http';
import 'rxjs/Rx';
import { Observable } from 'rxjs/Rx';
import { ConfigService } from '../../config/config.service';
import { SessionService } from './session.service';
import { Router } from '@angular/router';

@Injectable()
export class httpExtensionService {

    constructor(private http: Http, private config: ConfigService, private sessionService: SessionService, private router: Router) { }

    get(url: string, options?: RequestOptionsArgs) {
        let options1 = new RequestOptions({ method: RequestMethod.Get });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    post(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Post, body: body });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    put(url: string, body: any, options?: RequestOptionsArgs): Observable<any> {
        let options1 = new RequestOptions({ method: RequestMethod.Put, body: body });
        options1 = options1.merge(options);
        return this.sendRequest(url, options1);
    }

    delete(url: string, options?: RequestOptionsArgs): Observable<any> {
      let options1 = new RequestOptions({ method: RequestMethod.Delete });
      options1 = options1.merge(options);
      return this.sendRequest(url, options1);
    }

    private sendRequest(url: string, options: RequestOptionsArgs): Observable<any> {
       //make a copy
       let options1 = new RequestOptions();
       options1.method = options.method;
       options1 = options1.merge(options);

       //var resource = this.adalService.GetResourceForEndpoint(url);
       var authenticatedCall: Observable<any>;

      /// (data: Response) => data.json()
       if (this.sessionService.haveToRefresh()) {
               authenticatedCall = this.sessionService.refreshToken()
                   .flatMap((token: any) => {
                       //debugger;
                       this.sessionService.destroySessionCookie(false);
                       this.sessionService.rememberUser(token.accessToken);
                       this.sessionService.rememberRefreshToken(token.refreshToken);
                       this.sessionService.setSessionCookie(token.accessToken, token.expiresInSeconds);
                       this.sessionService.setRefreshToken(token.refreshToken);
                       if (options1.headers == null) {
                           options1.headers = new Headers();
                       }
                       options1.headers.set('Authorization', 'Bearer ' + token.accessToken);
                       return this.http.request(url, options1)
                           .map(this.extractData).catch(this.handleError.bind(this));
                   });
       }
       else {
           //this.sessionService.refreshTokensDurationOnEveryCall();
           authenticatedCall = this.http.request(url, options).map(this.extractData).catch(this.handleError.bind(this));
       }

       return authenticatedCall;
    }

    private extractData(res: Response) {
       if (res.status < 200 || res.status >= 300) {
           throw new Error('Bad response status: ' + res.status);
       }

       var body = {};
       //if there is some content, parse it to json or text
       if (res.status != 204) {
           if('application/csv;charset=UTF-8' === res.headers.get("content-type") || 'text/csv;charset=UTF-8' === res.headers.get("content-type") ) {
              body = res.text();
          } else if(res.headers.get("content-type").indexOf('ms-excel') > -1){
              body = res;
              var headers = res.headers;
              var contentDisposition= headers.get('content-disposition');
          } else {
               body = res.json();
          }
       }

       return body || {};
    }

    private handleError(error: any) {
        if( error && (( 403 === error.status ) || ( 401 === error.status ))) {
            if(this.router &&  ('function' === typeof this.router.navigate)) {
                this.sessionService.logout();
                this.router.navigate(['/']);
            }
            return Observable.throw(error.json());
            //return;
        } else {
            return Observable.throw(error.json());
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/httpextension.service.ts